import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import {
  MetaTags,
  formatTitle,
  standardMetaTags,
} from 'approot/shared/helmet/helmet';
import { NAMESPACE_TRANSLATION } from 'internationalise';
import { useRegionData } from 'approot/shared/region/region.apollo';

type Props = {
  meta?: MetaTags;
};

const LayoutMeta = ({ meta }: Props) => {
  const { t } = useTranslation(NAMESPACE_TRANSLATION);
  const { region, isRegionAU } = useRegionData();
  return meta ? (
    <Helmet>
      <title>{formatTitle(region, meta && (meta.title || meta.name))}</title>
      {standardMetaTags(meta, t, isRegionAU)}
    </Helmet>
  ) : (
    <Helmet>
      <title>Inquisitive</title>
    </Helmet>
  );
};

export default LayoutMeta;
